exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__wfpBoxCentered___2FTx0{background:#fff;position:relative;width:380px;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);padding:2rem;box-shadow:0 1px 4px rgba(0,0,0,.5)}", ""]);

// Exports
exports.locals = {
	"wfpBoxCentered": "styles__wfpBoxCentered___2FTx0"
};